module.exports = __webpack_public_path__ + "img/early-warning-armed-badge.edf25994.svg";